
import { t } from '@nextcloud/l10n'
import NcActionButton from '@nextcloud/vue/components/NcActionButton'
import NcActions from '@nextcloud/vue/components/NcActions'
import NcIconSvgWrapper from '@nextcloud/vue/components/NcIconSvgWrapper'
import Folder from 'vue-material-design-icons/Folder.vue'
import Plus from 'vue-material-design-icons/Plus.vue'
import PollIcon from 'vue-material-design-icons/Poll.vue'
import SlashForwardBox from 'vue-material-design-icons/SlashForwardBox.vue'
import Upload from 'vue-material-design-icons/Upload.vue'
import { EventBus } from '../../services/EventBus.ts'

export default {
	name: 'NewMessageAttachments',

	components: {
		NcActionButton,
		NcActions,
		NcIconSvgWrapper,
		// Icons
		Folder,
		Plus,
		PollIcon,
		SlashForwardBox,
		Upload,
	},

	props: {
		token: {
			type: String,
			required: true,
		},

		disabled: {
			type: Boolean,
			required: true,
		},

		canShareFiles: {
			type: Boolean,
			required: true,
		},

		canUploadFiles: {
			type: Boolean,
			required: true,
		},

		canCreatePoll: {
			type: Boolean,
			required: true,
		},
	},

	emits: ['update-new-file-dialog', 'open-file-upload', 'handle-file-share'],

	computed: {
		fileTemplateOptions() {
			return this.$store.getters.fileTemplates
		},

		shareFromNextcloudLabel() {
			return IS_DESKTOP
				? t('spreed', 'Share from {nextcloud}', { nextcloud: OC.theme.productName })
				: t('spreed', 'Share from Files')
		},
	},

	methods: {
		t,

		showSmartPicker() {
			EventBus.emit('smart-picker-open')
		},

		showPollEditor() {
			EventBus.emit('poll-editor-open', { id: null, fromDrafts: false })
		},
	},
}
